<template>
  <div :class="`accordion accordion-playlist-${this.videoPlaylist.id} pl-2 pr-2`">
    <div class="card p-0">
      <div 
        class="d-flex flex-row justify-content-between m-3 accordion-btn" 
        v-bind:class="{'active': isActive}"
        v-on:click="toggleDrawer()">
        <h2 class="video-playlist-header">{{this.videoPlaylist.name}}</h2>
        <div class='toggle-open-btn'>
          <i v-show="isOpen" class="fas fa-chevron-down"></i>
          <i v-show="!isOpen" class="fas fa-chevron-right"></i>
        </div>
      </div>
      
      <VideoItemSidebar
        v-for="videoAssetVideoPlaylist in videoAssetVideoPlaylists"
        v-bind:video-asset-video-playlist="videoAssetVideoPlaylist"
        v-bind:video-asset="videoAssetVideoPlaylist.video_asset"
        v-show="isOpen"
        v-bind:selected="selectedSidebarItem(videoAssetVideoPlaylist)"
        :key="videoAssetVideoPlaylist.id"
        @click.native="emitSelectVideoAssetVideoPlaylist(videoAssetVideoPlaylist)"
        >
      </VideoItemSidebar>
    </div>
  </div>
</template>

<script>
import VideoItemSidebar from './VideoItemSidebar.vue';
export default {
  components: { 
    VideoItemSidebar 
  },

  name: 'VideoPlaylistDrawer',

  props: {
    videoPlaylist: {
      type: Object,
      required: true
    },
    selectedVideoAssetVideoPlaylist: {
      type: [Object, Boolean],
      required: true
    }
  },

  data () {
    return {
      isOpen: false
    }
  },

  methods: {
    toggleDrawer() {
      this.isOpen = !this.isOpen;
    },

    emitSelectVideoAssetVideoPlaylist (videoAssetVideoPlaylist) {
      window.EventBus.$emit('video-asset-video-playlist-selected', videoAssetVideoPlaylist);
    },

    selectedSidebarItem (videoAssetVideoPlaylist) {
      if (!videoAssetVideoPlaylist.id) {
        // this is for search results side drawer, videoAssetVideoPlaylists are mocked in search so have no id
        var selectedVideoAssetId = this.selectedVideoAssetVideoPlaylist.video_asset?.id
        var videoAssetId         = videoAssetVideoPlaylist.video_asset?.id
        if (selectedVideoAssetId && videoAssetId) {
          return selectedVideoAssetId === videoAssetId
        }
        return false
      }
      // default behavior
      return videoAssetVideoPlaylist.id == this.selectedVideoAssetVideoPlaylist.id
    }

  },

  watch: {
    isActive () {
      if (this.isActive) this.isOpen = true;
    },

    selectedVideoAssetVideoPlaylist () {
      // close all drawers when not visible
      if (!this.selectedVideoAssetVideoPlaylist) this.isOpen = false
    },
  },  

  computed: {
    videoAssetVideoPlaylists () {
      return this.videoPlaylist.video_assets.data;
    },

    visibleVideoAssetVideoPlaylists () {
      return this.isOpen 
        ? this.videoAssetVideoPlaylists 
        : [];
    },

    isActive () {
      return this.selectedVideoAssetVideoPlaylist.video_playlist_id === this.videoPlaylist.id;
    }
  },

  created () {
    if (this.isActive) this.isOpen = true
  },

  mounted () {
    if (this.isActive) this.isOpen = true
  }

}

</script>

<style scoped>
  .toggle-open-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .accordion-btn:hover {
    cursor: pointer;
  }
</style>